module.exports = __webpack_public_path__ + "assets/word_study.4de281b7.svg";